import { initializeApp } from "firebase/app";
//TODO: inserire evento analytics per apertura notifiche
var firebaseConfig = {
  apiKey: "AIzaSyAQq_HU2w_0du7AGygyrPF9sRiC6sCpCXU",
  authDomain: "api-project-150725646086.firebaseapp.com",
  projectId: "api-project-150725646086",
  storageBucket: "api-project-150725646086.appspot.com",
  messagingSenderId: "150725646086",
  appId: "1:150725646086:web:7bd44d2dfd4de3b22cf087",
  measurementId: "G-BN5DEF7CVL"
};
export var app = initializeApp(firebaseConfig);